// extracted by mini-css-extract-plugin
module.exports = {"tags__list-container":"core_tags__list-container__1G_1j"};